import { routeList } from '@/router/helpers/routes'

export default [{
	path: routeList.NON_AUTHENTICATED_CONTACTS_PATH,
	name: routeList.NON_AUTHENTICATED_CONTACTS_NAME,
	component: () => import('@/views/Contacts')
}, {
	path: routeList.CONTACTS_PATH,
	name: routeList.CONTACTS_NAME,
	component: () => import('@/views/Contacts')
}]
